import { EVENT_META, fmtDate, fmtKm, fmtTry, SEVERITY_LABELS } from "../lib/labels";

export default function Timeline({ history }) {
  return (
    <div data-testid="history-timeline-list" className="relative">
      <div className="absolute left-[19px] top-2 bottom-2 w-px bg-gradient-to-b from-cyan-500/50 via-slate-700 to-transparent" />
      <div className="space-y-5">
        {history.map((h, i) => {
          const meta = EVENT_META[h.type] || EVENT_META.tescil;
          return (
            <div key={h.id || i} data-testid={`timeline-item-${h.type}`}
              className="relative pl-14 animate-fade-up" style={{ animationDelay: `${Math.min(i * 60, 600)}ms` }}>
              <span className={`absolute left-0 top-0 w-10 h-10 rounded-full border flex items-center justify-center ${meta.ring}`}>
                <meta.Icon className={`w-4.5 h-4.5 w-[18px] h-[18px] ${meta.color}`} />
              </span>
              <div className="rounded-xl border border-white/10 bg-slate-900/60 hover:bg-slate-800/60 transition-colors p-4">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 justify-between">
                  <h4 className="font-semibold text-slate-100">{h.title}</h4>
                  <span className="text-xs font-mono-vin text-slate-400">{fmtDate(h.date)}</span>
                </div>
                <p className="text-sm text-slate-400 mt-1.5 leading-relaxed">{h.description}</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  <span className={`text-xs px-2.5 py-1 rounded-full border ${meta.ring} ${meta.color}`}>{meta.label}</span>
                  {h.km !== undefined && h.km !== null && (
                    <span className="text-xs px-2.5 py-1 rounded-full border border-white/10 text-slate-300">{fmtKm(h.km)}</span>
                  )}
                  {h.severity && (
                    <span className="text-xs px-2.5 py-1 rounded-full border border-red-500/30 text-red-300">
                      Şiddet: {SEVERITY_LABELS[h.severity] || h.severity}
                    </span>
                  )}
                  {fmtTry(h.cost) && (
                    <span className="text-xs px-2.5 py-1 rounded-full border border-white/10 text-slate-300">{fmtTry(h.cost)}</span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
